module.exports = __webpack_public_path__ + "img/704616f.png";